/**
 * Seeded PRNG for gameplay simulation.
 * Same seed + same call order → identical random stream (mulberry32).
 */

export function createMulberry32(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

let currentSeed = 1;
let rng: () => number = createMulberry32(1);

/** Start a new random stream. Omit `seed` for match-start entropy (becomes part of initial state). */
export function seedGameRng(seed?: number): number {
  if (seed != null && Number.isFinite(seed)) {
    currentSeed = seed >>> 0;
  } else {
    currentSeed =
      (Math.imul(Date.now() ^ ((performance.now() * 1000) | 0), 0x9e3779b9) >>> 0) || 1;
  }
  if (currentSeed === 0) currentSeed = 1;
  rng = createMulberry32(currentSeed);
  return currentSeed;
}

export function getGameRngSeed(): number {
  return currentSeed;
}

/** Uniform [0, 1). Use this instead of Math.random() in gameplay simulation. */
export function gameRandom(): number {
  return rng();
}

/** Override the active generator (e.g. multiplayer Highway uses a dedicated stream). */
export function setGameRandomFn(fn: () => number): void {
  rng = typeof fn === "function" ? fn : createMulberry32(currentSeed || 1);
}
